"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressFilledLevel = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var ProgressFilledLevel = function (_a) {
    var isLongToolTip = _a.isLongToolTip, color = _a.color, fillLevel = _a.fillLevel;
    return (react_1.default.createElement(antd_1.Progress, { percent: fillLevel || 0, strokeColor: color, status: "normal", style: {
            width: isLongToolTip === true ? "55%" : "80%",
            marginLeft: isLongToolTip === true ? 0 : 8,
            marginTop: isLongToolTip === true ? 0 : -2,
        } }));
};
exports.ProgressFilledLevel = ProgressFilledLevel;
